import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import UpdatePackagesContainer from './components/UpdatePackagesContainer';

const UpdatePackages = () => (
  <PageContainer pageName="update-jobs">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_UPDATE_MANAGEMENT}>
      <UpdatePackagesContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default UpdatePackages;
